import db from '../../versa/db.js';

export default async (results) =>		// { company_id: { output_id: { status: '' }, ... } }
`<style>
	#results 
	{ 
		width: 100%; 
		border-collapse: collapse; 
	}
	#results td 
	{ 
		border: 1px solid lightgray;
		padding: var(--space-sm); 
	}
</style>
<table id="results" style="width: 100%;">` + (
	await Promise.all(
		Object.keys(results).map(async company_id => 
			`<tr>` + 
				`<td class="tac" colspan="3">${(await db.get('companies', company_id)).nick}</td>` +
			`</tr>` +
			Object.keys(results[company_id]).map(output =>
				`<tr>` + 
					`<td class="tal">Saída&nbsp;${output}</td>` + 
					`<td class="tal">${results[company_id][output]['status']}</td>` + 
				`</tr>`
			).join('')
		)
	)
).join('') + 
`</table>`;

